import { lazy } from "react";
import { Navigate } from "react-router-dom";

const isAllowedTime = () => {
  // const now = new Date();

  // //  Cutoff date (2 April 2026)
  // const cutoffDate = new Date(2026, 3, 2); // Month is 0-based (3 = April)

  // //  If today is AFTER 2 April 2026 → always allow
  // if (now > cutoffDate) {
  //   return true;
  // }

  // //  Otherwise apply time restriction
  // const start = new Date();
  // start.setHours(8, 0, 0); // 11:00 AM

  // const end = new Date();
  // end.setHours(21, 0, 0); // 7:00 PM

  // // NOT allowed between 11–7
  // //  Allowed outside this time
  // return !(now >= start && now <= end);

  return true;
};

export const expenditureRoutes = [
  // { path: "/PendingList", component: lazy(() => import("../../Components/ContinigentExpenditure/PendingList")) },

  // ✅ Conditionally include PendingList
  ...(isAllowedTime()
    ? [
      {
        path: "/PendingList",
        component: lazy(
          () => import("../../Components/ContinigentExpenditure/PendingList"),
        ),
      },
    ]
    : [
      {
        path: "/PendingList",
        component: () => <Navigate to="/sidebar" />,
      },
    ]),

  ...(isAllowedTime()
    ? [
      {
        path: "/ContingentExpenditure",
        component: lazy(
          () =>
            import("../../Components/ContinigentExpenditure/ContinigentExpenditure"),
        ),
      },
    ]
    : [
      {
        path: "/ContingentExpenditure",
        component: () => <Navigate to="/sidebar" />,
      },
    ]),

  // { path: "/ContingentExpenditure", component: lazy(() => import("../../Components/ContinigentExpenditure/ContinigentExpenditure")) },

  {
    path: "/ServiceMaster",
    component: lazy(() => import("../../Components/Masters/ServiceMaster")),
  },
  {
    path: "/DepartmentMaster",
    component: lazy(() => import("../../Components/Masters/DepartmentMaster")),
  },
  {
    path: "/expdtlheadmast",
    component: lazy(() => import("../../Components/Masters/Exp_DtlHeadMast")),
  },
  {
    path: "/SubDetailedMaster",
    component: lazy(
      () => import("../../Components/ContinigentExpenditure/SubDetailedMaster"),
    ),
  },
  {
    path: "/ExpenditureItemDetailsMaster",
    component: lazy(
      () => import("../../Components/Masters/ExpenditureItemDetailsMaster"),
    ),
  },
  {
    path: "/HeadDetaillsAcGrade",
    component: lazy(
      () =>
        import("../../Components/ContinigentExpenditure/HeadDetaillsAcGrade"),
    ),
  },
  {
    path: "/HeadOfAccountMaster",
    component: lazy(
      () =>
        import("../../Components/ContinigentExpenditure/HeadOfAccountMaster"),
    ),
  },
  {
    path: "/DrawlModeMaster",
    component: lazy(() => import("../../Components/Masters/DrawlModeMaster")),
  },
  {
    path: "/ExpenditureDeductionDetailsMaster",
    component: lazy(
      () =>
        import("../../Components/Masters/ExpenditureDeductionDetailsMaster"),
    ),
  },
  {
    path: "/UnitMeasurementsMaster",
    component: lazy(
      () => import("../../Components/Masters/UnitMeasurementsMaster"),
    ),
  },
  {
    path: "/panchayatexpgradmaster",
    component: lazy(
      () => import("../../Components/Masters/PanchayatGradMaster"),
    ),
  },
  {
    path: "/sectormaster",
    component: lazy(() => import("../../Components/Masters/SectorMast")),
  },
  {
    path: "/SectorItemMaster",
    component: lazy(
      () => import("../../Components/ContinigentExpenditure/SectorItemMaster"),
    ),
  },
  {
    path: "/DesignationMaster",
    component: lazy(() => import("../../Components/Masters/DesignationMaster")),
  },
  {
    path: "/CategoryofPostMaster",
    component: lazy(
      () => import("../../Components/Masters/CategoryofPostMaster"),
    ),
  },
  {
    path: "/NatureofWorkMaster",
    component: lazy(
      () => import("../../Components/Masters/NatureofWorkMaster"),
    ),
  },
  {
    path: "/ItemAndGeneralSpecificationMaster",
    component: lazy(() => import("../../Components/Masters/ItemMaster")),
  },
  {
    path: "/sdpwmapmast",
    component: lazy(
      () => import("../../Components/Masters/SecDisPCNoWMapStatus"),
    ),
  },

  {
    path: "/ContractService",
    component: lazy(
      () => import("../../Components/ExpenditureMasters/ContractService"),
    ),
  },
  {
    path: "/NMRMaster",
    component: lazy(
      () => import("../../Components/ExpenditureMasters/NMRMaster"),
    ),
  },
  { path: "/NMROthersServices", component: lazy(() => import("../../Components/ExpenditureMasters/NMROthersServices")) },
  {
    path: "/MaterialProcurement",
    component: lazy(
      () =>
        import("../../Components/ExpenditureMasters/MaterialProcurementNewScreen"),
    ),
  },
  {
    path: "/materialprocstausrep",
    component: lazy(
      () => import("../../Components/Masters/MaterialProcStatusRepDist"),
    ),
  },
  {
    path: "/StatusOfExpenditure",
    component: lazy(
      () =>
        import("../../Components/ContinigentExpenditure/StatusOfExpenditure"),
    ),
  },
  {
    path: "/OutSourcingService",
    component: lazy(
      () => import("../../Components/ExpenditureMasters/OutSouringService"),
    ),
  },
  {
    path: "/e-kycStatusOfNMR",
    component: lazy(
      () => import("../../Components/ExpenditureMasters/EkycStatusOfNMR"),
    ),
  },

  {
    path: "/e-kycStatusOfNMR",
    component: lazy(
      () => import("../../Components/ExpenditureMasters/EkycStatusOfNMR"),
    ),
  },

  {
    path: "/wagesSubmit",
    component: lazy(
      () => import("../../Components/ContinigentExpenditure/WagesNewSubmit"),
    ),
  },
  {
    path: "/WorksEntryScreen",
    component: lazy(
      () => import("../../Components/ExpenditureMasters/WorksEntryScreen"),
    ),
  },
  {
    path: "/WorksEditScreen",
    component: lazy(
      () => import("../../Components/ExpenditureMasters/WorksEditScreen"),
    ),
  },
  {
    path: "/WorksApprovalScreenDpo",
    component: lazy(
      () =>
        import("../../Components/ExpenditureMasters/WorksApprovalScreenDpo"),
    ),
  },

  {
    path: "/WorksContingentBill",
    component: lazy(
      () => import("../../Components/ExpenditureMasters/WorksContingentBill"),
    ),
  },

  {
    path: "/WorksContingentBillApproval",
    component: lazy(
      () =>
        import("../../Components/ExpenditureMasters/WorksContingentBillApproval"),
    ),
  },

  {
    path: "/VehicleMaster",
    component: lazy(
      () => import("../../Components/ContinigentExpenditure/VehicleMaster"),
    ),
  },

  {
    path: "/VehicalMasterReport",
    component: lazy(
      () =>
        import("../../Components/ContinigentExpenditure/VehicalMasterReport"),
    ),
  },

  {
    path: "/WagesRenewalVendors",
    component: lazy(
      () => import("../../Components/ExpenditureMasters/WagesRenewalVendors"),
    ),
  },
  {
    path: "/ExpVendorReport",
    component: lazy(
      () => import("../../Components/ExpenditureMasters/ExpVendorReport"),
    ),
  },

  {
    path: "/RaiseIndentWindow",
    component: lazy(
      () => import("../../Components/ExpenditureMasters/RaiseIndentWindow"),
    ),
  },
  {
    path: "/stockEntry",
    component: lazy(
      () => import("../../Components/ExpenditureMasters/StockEntry"),
    ),
  },
  {
    path: "/stockIssue",
    component: lazy(
      () => import("../../Components/ExpenditureMasters/StockIssue"),
    ),
  },

  {
    path: "/DownloadPurchaseOrder",
    component: lazy(() => import("../../DownloadPurchaseOrder")),
  },
  {
    path: "/purchase-order-view",
    component: lazy(() => import("../../PurchaseOrderView")),
  },

  {
    path: "/DownloadStockReceiptNote",
    component: lazy(
      () => import("../../Components/ContinigentExpenditure/StockReceiptNote"),
    ),
  },
  {
    path: "/StockReceiptNoteView",
    component: lazy(
      () =>
        import("../../Components/ContinigentExpenditure/StockReceiptNoteView"),
    ),
  },

  {
    path: "/DownloadStockIssue",
    component: lazy(
      () =>
        import("../../Components/ContinigentExpenditure/DownloadStockIssue"),
    ),
  },
  {
    path: "/DownloadStockIssueView",
    component: lazy(
      () =>
        import("../../Components/ContinigentExpenditure/DownloadStockIssueView"),
    ),
  },

  {
    path: "/ProcurementContigentBill",
    component: lazy(
      () =>
        import("../../Components/ExpenditureMasters/ProcurementContigentBill"),
    ),
  },

  {
    path: "/ProcurementContigentBillApproval",
    component: lazy(
      () =>
        import("../../Components/ExpenditureMasters/ProcurementContigentBillApproval"),
    ),
  },

  {
    path: "/MiscellaneousContingentExp",
    component: lazy(
      () =>
        import("../../Components/ContinigentExpenditure/ContingentExpendMiscellaneous"),
    ),
  },
  {
    path: "/ContingentExpendMiscellaneous",
    component: lazy(() => import("../../UnderConstruction")),
  },
  {
    path: "/ContingentApprovalExpenditure",
    component: lazy(
      () =>
        import("../../Components/ContinigentExpenditure/ContingentApprovalExpenditure"),
    ),
  },

  {
    path: "/MisOverallExpenditureReport",
    component: lazy(
      () =>
        import("../../Components/ExpenditureMasters/MisOverallExpenditureReport"),
    ),
  },

  {
    path: "/ContigencyBillsPendingForApprovalReport",
    component: lazy(
      () =>
        import("../../Components/ContinigentExpenditure/ContigencyBillsPendingForApprovalReport"),
    ),
  },

  {
    path: "/PendingExpRep",
    component: lazy(
      () =>
        import("../../Components/ExpenditureMasters/SLAPendingExpenditureRep"),
    ),
  },
  {
    path: "/ExpenditureBillsReport",
    component: lazy(
      () =>
        import("../../Components/ExpenditureMasters/ExpenditureBillsReport"),
    ),
  },
  {
    path: "/WorksDetailsReport",
    component: lazy(
      () => import("../../Components/ExpenditureMasters/WorksDetailsReport"),
    ),
  },


  { path: "/expenditureInspection", component: lazy(() => import("../../Components/ExpenditureMasters/ExpenditureInspection.js")) },
  { path: "/expenditureInspectionDPOLevel", component: lazy(() => import("../../Components/ExpenditureMasters/ExpenditureInspectionDPOLevel.js")) },
  { path: "/receivedBillsFromDLDOForCrossVerification", component: lazy(() => import("../../Components/ExpenditureMasters/ExpenditureInspectionDPOLevel2.js")) },

  { path: "/ExpenditureBillVerificationReport", component: lazy(() => import("../../Components/ExpenditureMasters/ExpenditureBillVerificationReport.js")) },

];
